module.exports = __webpack_public_path__ + "img/FAIR.fa296a30.svg";